/**
 * Paleta + métricas comunes a todas las tablas del report de
 * Eficacia. Inspiradas en Polaris IndexTable para que la lectura
 * sea consistente con el resto del admin.
 */

export const TABLE_BORDER = '#E1E3E5';
export const TABLE_HEADER_BG = '#F6F6F7';
// Color del título principal del header (línea 1). Oscuro siempre para
// legibilidad sobre el gris claro del header.
export const TABLE_HEADER_TEXT_STRONG = '#202223';
// Color del sub-título (línea 2 entre paréntesis) — más suave.
export const TABLE_HEADER_TEXT_SOFT = '#5C5F62';
export const TABLE_BODY_TEXT = '#202223';
export const TABLE_ROW_ODD = '#FFFFFF';
export const TABLE_ROW_EVEN = '#F9FAFB';
export const TABLE_ROW_HOVER = '#F1F2F4';
export const TABLE_TOTAL_BG = '#FAFBFB';
export const TABLE_SUBTLE = '#5C5F62';
export const TABLE_POSITIVE = '#0F7B3E';
export const TABLE_DANGER = '#C0392B';
export const TABLE_INTERACTIVE = '#2C6ECB';
export const TABLE_CELL_BORDER = `1px solid ${TABLE_BORDER}`;
export const TABLE_CELL_PADDING = { padding: '12px 16px' };
